import { Styles, css } from "@styled-system/css";

const centerFlex: Styles = {
	display: "flex",
	justifyContent: "center",
};

const filterRowClass = css({
	display: "flex",
	alignItems: "center",
	gap: "2",
	mb: "4",
});

const emptyStateClass = css({
	textAlign: "center",
	py: "4",
	mb: "8",
	color: "shade.100",
	borderRadius: "20",
	border: "1px solid",
	borderColor: "shade.40",
});

const mainContainerClass = css({
	display: "flex",
	flexDirection: "column",
	gap: "8",
});

const paginationControllersClass = css({
	...centerFlex,
	gap: "16",
});

const loadingTemplateClass = css({
	...centerFlex,
	padding: "8",
});

const idDisplayContainerClass = css({
	display: "flex",
	alignItems: "center",
	gap: "8",
});

const createdAtContainerClass = css({
	...centerFlex,
});

export const styles = {
	filterRow: filterRowClass,
	emptyState: emptyStateClass,
	mainContainer: mainContainerClass,
	paginationControllers: paginationControllersClass,
	loadingTemplate: loadingTemplateClass,
	idDisplayContainer: idDisplayContainerClass,
	createdAtContainer: createdAtContainerClass,
};
